// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import { Navigation, Pagination, Scrollbar, A11y, FreeMode, Thumbs, Autoplay } from 'swiper'
import Up from "../Assets/Up.png"
import Down from "../Assets/Down.png"
import Leftarrow from "../Assets/Leftarrow.png"
import Rightarrow from "../Assets/Rightarrow.png"
import expicon from "../Assets/expicon.png"
import Back from "../Assets/Back.png"
import Left from "../Assets/Left.png"
import Right from "../Assets/Right.png"
import {Modal} from "@mui/material"

// Import Swiper styles
import 'swiper/css';
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import "swiper/css/thumbs";

import { useEffect, useRef, useState } from 'react';
import ImageContent from '../Utils/ImageContent';
import TestimonialCard from '../Utils/Testimonial';
import YouTube from 'react-youtube'
import { AiOutlineClose } from 'react-icons/ai';


const SwiperCompcopy=() => {
  let properties=["Sushma Elementa","Aroha De Goa","Rio De Goa","The Swiss Village"]
 
  const [select,setselect]=useState("The Swiss Village")
  function importAll(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  }
  

const images = importAll(require.context('../Assets', false, /\.(png|webp|jpe?g|svg|mp4)$/));
const[sliderdata,setsliderdata]=useState([])
const[testimonialdata,settestimonialdata]=useState([])
const [swiper,setSwiper]=useState(null)
const [videourl,setvideourl]=useState("")
const[videoswiper,setvideoswiper]=useState(null)
const[zoomimage,setzoomimage]=useState(false)
const[zoomimagelarge,setzoomimagelarge]=useState(false)
const[modaldata,setmodaldata]=useState([])
const navigationPrevRef=useRef(null)
const navigationNextRef=useRef(null)
const zoomimagedata=[
    {
        "Sushma Elementa":[
        images['Sushma(1).webp'],images['Sushma(2).webp'],images['Sushma(3).webp'],
        images['Sushma(4).webp'],images['Sushma(5).webp'],images['Sushma(6).webp']
    ]
},
{
    "Aroha De Goa":[
    images['Aroha(1).webp'],images['Aroha(2).webp'],images['Aroha(3).webp'],
    images['Aroha(4).webp'],images['Aroha(5).webp']
    ]
},
{
"Rio De Goa":[
    images['Rio(1).webp'],images['Rio(2).webp'],images['Rio(3).webp'],
    images['Rio(4).webp'],images['Rio(5).webp'],images['Rio(6).webp'],
    ]
},
// {
//     "Amrut Farms":[
//         images['Amrut(1).webp'],images['Amrut(2).webp'],images['Amrut(3).webp'],
//         images['Amrut(4).webp'],images['Amrut(5).webp'],images['Amrut(6).webp'],
// ]
// },
{
    "The Swiss Village":[
        images['Swiss(1).webp'],images['Swiss(2).webp'],images['Swiss(3).webp'],
        images['Swiss(4).webp'],images['Swiss(5).webp'],images['Swiss(6).webp'],
        images['Swiss(7).webp'],images['Swiss(8).webp'],images['Swiss(9).webp'],
]
}
]
const imagedata=[
    {
        "Sushma Elementa":[
        [images['Sushma(1).webp'],images['Sushma(2).webp'],images['Sushma(3).webp']],
        // [images['Sushma(4).jpeg'],images['Sushma(5).webp'],images['Sushma(6).webp']]
    ]
},
{
    "Aroha De Goa":[
    [images['Aroha(1).webp'],images['Aroha(2).webp'],images['Aroha(3).webp']],
    // [images['Aroha(4).webp'],images['Aroha(5).webp'],images['Aroha(6).webp']],
    // [images['Aroha(7).webp'],images['Aroha(8).webp'],images['Aroha(9).webp']]
    ]
},
{
"Rio De Goa":[
    [images['Rio(1).webp'],images['Rio(2).webp'],images['Rio(3).webp']],
    // [images['Rio(4).webp'],images['Rio(5).webp'],images['Rio(6).webp']],
    ]
},
// {
//     "Amrut Farms":[
//         [images['Amrut(1).webp'],images['Amrut(2).webp'],images['Amrut(3).webp']],
//         // [images['Amrut(4).webp'],images['Amrut(5).webp'],images['Amrut(6).webp']],
// ]
// },
{
    "The Swiss Village":[
        [images['Swiss(1).webp'],images['Swiss(2).webp'],images['Swiss(3).webp']],
        // [images['Swiss(4).webp'],images['Swiss(5).webp'],images['Swiss(6).png']],
]
},
]
const testimonials=[
    {
        "Sushma Elementa":[
            [
                "JoYMWbrzNsA",
                "Dr. Tanu Dang & Devendra Dang",
                images['Tanu.png']
            ],
            [
                "",
                "Mr. Abhijit Thombre",
                "BRIK itt is an excellent alternative investment platform to diversify your portfolio. I always wanted to have holiday homes in unique locations near to beach, mountains, snow. But making full investment was financial challenge for me and maintenance is another headache. And magically BRIK itt came into my notice and made my dream come true. Now I can have holiday homes in multiple beautiful places where me and my family can visit and enjoy in our leisure time without worrying about maintenance and upkeep of the property."
            ],
            [
                "",
                "Anoop Singh",
                "BRIKitt for me comes as an opportunity to make my DREAM of owing a Holiday Home come true. Thanks to BRIKitt for this brilliant opportunity of pocket friendly investment. I am really satisfied with the efficiency and professionalism shown whilst completing the onboarding. BRIKitt is highly recommended and BRIK is worth including in your investment portfolio."

            ],
            [
                "",
                "Mr. Sanjay Koul",
                "I must say that I was bit worried when I signed up with BRIKitt, but as I dealt with them, I was pleasantly surprised at their speed and professionalism. I am very happy with BRIK itt and would be happy recommending them to my friends."
            ],
            [
                "",
                "Shubha Bisotra",
                "Having been born and brought up in the hill state of Himachal and visiting Kasauli throughout my childhood, I always dreamt of having something to call my own in this beautiful hill station. I am super exited for this novel investment opportunity. Looking forward to using the property soon. All the best to the ever so helpful and enterprising BRIK itt Team." 
            ]
        ]
    },
    {
        "Aroha De Goa":[
            [
                "XtclwqOGYRY",
                "Ms. Suja Das & Ms. Kuldeep Kaur",
                images['Suja.png']
            ],
            [
                "",
                "Mr. Abhijit Thombre",
                "BRIK itt is an excellent alternative investment platform to diversify your portfolio. I always wanted to have holiday homes in unique locations near to beach, mountains, snow. But making full investment was financial challenge for me and maintenance is another headache. And magically BRIK itt came into my notice and made my dream come true. Now I can have holiday homes in multiple beautiful places where me and my family can visit and enjoy in our leisure time without worrying about maintenance and upkeep of the property."
            ],
            [
                "",
                "Anoop Singh",
                "BRIKitt for me comes as an opportunity to make my DREAM of owing a Holiday Home come true. Thanks to BRIKitt for this brilliant opportunity of pocket friendly investment. I am really satisfied with the efficiency and professionalism shown whilst completing the onboarding. BRIKitt is highly recommended and BRIK is worth including in your investment portfolio."

            ],
            [
                "",
                "Mr. Sanjay Koul",
                "I must say that I was bit worried when I signed up with BRIKitt, but as I dealt with them, I was pleasantly surprised at their speed and professionalism. I am very happy with BRIK itt and would be happy recommending them to my friends."
            ],
            [
                "",
                "Shubha Bisotra",
                "Having been born and brought up in the hill state of Himachal and visiting Kasauli throughout my childhood, I always dreamt of having something to call my own in this beautiful hill station. I am super exited for this novel investment opportunity. Looking forward to using the property soon. All the best to the ever so helpful and enterprising BRIK itt Team." 
            ]
        ]
    },
    {
        "Rio De Goa":[
            // [
            //     "KmqVcs7MopA",
            //     "Deb Krishna Bhattacharya",
            //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ng elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur"
            // ],
            [
                "G8FquTYCDWg",
                "Ms. Liane Ghosh",
                images['Liane.png']
            ],
            [
                "JEJE0pNsI6U",
                "Mr. Gadhvi Aniruddhsinh Kishorsinh",
                images['Gadhvi.png']
            ],
            [
                "PpYJ_-uMCms",
                "Mr. Sulakshana Nagesh Gangolly",
                images['Nagesh.png']
            ],
            [
                "",
                "Mr. Armaan Ohri",
                "It was always my childhood dream to have homes at several locations. BRIK itt has made it possible. Now with the growth of BRIK itt I see my dream also grow. One of the best decisions I made. I recently stayed in Rio de Goa and expectations were exceeded."
            ],
            [
                "",
                "Mr. Abhijit Thombre",
                "BRIK itt is an excellent alternative investment platform to diversify your portfolio. I always wanted to have holiday homes in unique locations near to beach, mountains, snow. But making full investment was financial challenge for me and maintenance is another headache. And magically BRIK itt came into my notice and made my dream come true. Now I can have holiday homes in multiple beautiful places where me and my family can visit and enjoy in our leisure time without worrying about maintenance and upkeep of the property."
            ],
            [
                "",
                "Anoop Singh",
                "BRIKitt for me comes as an opportunity to make my DREAM of owing a Holiday Home come true. Thanks to BRIKitt for this brilliant opportunity of pocket friendly investment. I am really satisfied with the efficiency and professionalism shown whilst completing the onboarding. BRIKitt is highly recommended and BRIK is worth including in your investment portfolio."

            ],
            [
                "",
                "Mr. Sanjay Koul",
                "I must say that I was bit worried when I signed up with BRIKitt, but as I dealt with them, I was pleasantly surprised at their speed and professionalism. I am very happy with BRIK itt and would be happy recommending them to my friends."
            ],
            [
                "",
                "Shubha Bisotra",
                "Having been born and brought up in the hill state of Himachal and visiting Kasauli throughout my childhood, I always dreamt of having something to call my own in this beautiful hill station. I am super exited for this novel investment opportunity. Looking forward to using the property soon. All the best to the ever so helpful and enterprising BRIK itt Team." 
            ]

        ]
    },
    {
        "Amrut Farms":[
            [
                "JoYMWbrzNsA",
                "Dr. Tanu Dang & Devendra Dang",
                images['Tanu.png']
            ],[
                "",
                "Mr. Abhijit Thombre",
                "BRIK itt is an excellent alternative investment platform to diversify your portfolio. I always wanted to have holiday homes in unique locations near to beach, mountains, snow. But making full investment was financial challenge for me and maintenance is another headache. And magically BRIK itt came into my notice and made my dream come true. Now I can have holiday homes in multiple beautiful places where me and my family can visit and enjoy in our leisure time without worrying about maintenance and upkeep of the property."
            ],
            [
                "",
                "Anoop Singh",
                "BRIKitt for me comes as an opportunity to make my DREAM of owing a Holiday Home come true. Thanks to BRIKitt for this brilliant opportunity of pocket friendly investment. I am really satisfied with the efficiency and professionalism shown whilst completing the onboarding. BRIKitt is highly recommended and BRIK is worth including in your investment portfolio."

            ],
            [
                "",
                "Mr. Sanjay Koul",
                "I must say that I was bit worried when I signed up with BRIKitt, but as I dealt with them, I was pleasantly surprised at their speed and professionalism. I am very happy with BRIK itt and would be happy recommending them to my friends."
            ],
            [
                "",
                "Shubha Bisotra",
                "Having been born and brought up in the hill state of Himachal and visiting Kasauli throughout my childhood, I always dreamt of having something to call my own in this beautiful hill station. I am super exited for this novel investment opportunity. Looking forward to using the property soon. All the best to the ever so helpful and enterprising BRIK itt Team." 
            ]
        ]
    },
    {
        "The Swiss Village":[
            [
                "JoYMWbrzNsA",
                "Dr. Tanu Dang & Devendra Dang",
                images['Tanu.png']
            ],
            [
                "",
                "Mr. Abhijit Thombre",
                "BRIK itt is an excellent alternative investment platform to diversify your portfolio. I always wanted to have holiday homes in unique locations near to beach, mountains, snow. But making full investment was financial challenge for me and maintenance is another headache. And magically BRIK itt came into my notice and made my dream come true. Now I can have holiday homes in multiple beautiful places where me and my family can visit and enjoy in our leisure time without worrying about maintenance and upkeep of the property."
            ],
            [
                "",
                "Anoop Singh",
                "BRIKitt for me comes as an opportunity to make my DREAM of owing a Holiday Home come true. Thanks to BRIKitt for this brilliant opportunity of pocket friendly investment. I am really satisfied with the efficiency and professionalism shown whilst completing the onboarding. BRIKitt is highly recommended and BRIK is worth including in your investment portfolio."

            ],
            [
                "",
                "Mr. Sanjay Koul",
                "I must say that I was bit worried when I signed up with BRIKitt, but as I dealt with them, I was pleasantly surprised at their speed and professionalism. I am very happy with BRIK itt and would be happy recommending them to my friends."
            ],
            [
                "",
                "Shubha Bisotra",
                "Having been born and brought up in the hill state of Himachal and visiting Kasauli throughout my childhood, I always dreamt of having something to call my own in this beautiful hill station. I am super exited for this novel investment opportunity. Looking forward to using the property soon. All the best to the ever so helpful and enterprising BRIK itt Team." 
            ]
        ]
    }
]
let findprop=(name)=>
{
    let index
    properties?.forEach((e,i)=>
    {
        if(e==name)
        {
            index= i;
        }
    })
    return index

}
const handleclick=()=>
{
    let arr=zoomimagedata?.filter((e,i)=>(Object.keys(e)==select))
    setmodaldata(arr?.[0][select])
    setzoomimage(true)
}
const handleclicklarge=()=>
{
    let arr=zoomimagedata?.filter((e,i)=>(Object.keys(e)==select))
    setmodaldata(arr?.[0][select])
    setzoomimagelarge(true)
}
const restorezoomdefault=()=>
{
    setzoomimage(false)
    setzoomimagelarge(false)
}

useEffect(()=>
    {
        let arr=imagedata?.filter((e,i)=>(Object.keys(e)==select))
        setsliderdata(arr?.[0][select])
        const interval=setInterval(()=>
        {
            const currentIndex=properties.indexOf(select)
            const nextIndex = (currentIndex + 1) % properties.length;
            setselect(properties[nextIndex]);
            let arr=imagedata?.filter((e,i)=>(Object.keys(e)==properties[nextIndex]))
            setsliderdata(arr?.[0][properties[nextIndex]])
            
            // let dummy=testimonials?.filter((e,i)=>(Object.keys(e)==select))
            
            // settestimonialdata(dummy?.[0][select])
        },8000)
        return () => {
            clearInterval(interval);
          };
        
        

    },[select])

    
    

    return (
        <div className='sm:px-[16px] sm:py-[30px] lg:px-[158px] lg:pt-[60px]'>
            <p style={{fontFamily:"Playfair Display"}} className='text-[#C69130] sm:text-[28px] lg:text-[35px] font-[600] sm:leading-[37px] lg:leading-[56px] tracking-[0.5px] sm:mb-[25px] lg:mb-[25px]'>Our Premier Portfolio of Managed Properties</p>
            <div id='imageswiper' className='flex items-center gap-[20px]'>
                <div className='flex flex-col gap-[30px] w-[20%]'>
                    {
                        properties?.map((e)=>
                        {
                            return(
                                <div id='activeeffect' className='flex gap-[12px] items-center'>
                                    <div>
                                    {e==select?<img src={images['Prop.png']}/>:<></>}
                                    </div>
                                    <p onClick={()=>
                                    {
                                        setselect(e)
                                    }} style={{fontFamily:"Inter"}} className={select==e?'cursor-pointer text-[24px] text-[#442800] font-[700] leading-[30px]':'cursor-pointer text-[16px] text-[#656565] font-[500] leading-[20px]'}>{e}</p>
                                </div>
                            )
                        })
                    }
                    
                </div>
                {/* <div className='pt-[280px] h-full flex flex-col justify-end items-end'>
                    <img src={Up} id='swiper-button-prev' className='w-auto mb-[20px] cursor-pointer'></img>
                    <img src={Down} id="swiper-button-next" className='w-auto cursor-pointer'></img>
                </div> */}
                <div className='w-[100%] h-full'>
                {
                    sliderdata?.map((e,i)=>
                    {
                        return(
                                <ImageContent handleclick={handleclicklarge} zoomimage={zoomimagelarge} setzoomimage={setzoomimagelarge} url1={e[0]} url2={e[1]} url3={e[2]} />
                               
                            )
                    })
                }
                </div>
                {/* <Swiper
                onSwiper={setSwiper}
                navigation={{
                    prevEl:'#swiper-button-prev',
                    nextEl:'#swiper-button-next',
                }}
                modules={[Pagination, Navigation, Autoplay]}
                pagination= {{
                    el: '.swiper-custom-pagination',
                  }}
                className="swiperforimage"
                direction='horizontal'
                autoplay={{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter:true}}
                onReachEnd={()=>{
                    let index=findprop(select)
                    index==properties.length-1?setselect(properties[0]):setselect(properties[index+1])
                }}
                 >
                {
                    sliderdata?.map((e,i)=>
                    {
                        return(
                                <SwiperSlide className='swiper-slide' key={i}>
                                    <ImageContent swiper={swiper} setSwiper={setSwiper} zoomimage={zoomimage} setzoomimage={setzoomimage} url1={e[0]} url2={e[1]} url3={e[2]} />
                                </SwiperSlide>
                            )
                    })
                }
                <div className="swiper-custom-pagination"/>
                </Swiper> */}
                
            </div>
            <div className='sm:block lg:hidden'>
                <div className='flex justify-between items-center'>
                    <div id='activeeffect'>
                        <img onClick={()=>
                        {
                            let index=findprop(select)
                            let name
                            index==0?name=properties[properties.length-1]:name=properties[index-1]
                            setselect(name)
                        }} src={Leftarrow}/>
                    </div>
                    <p style={{fontFamily:"Inter"}} className='text-[#442800] text-[22px] font-[700] leading-[29px]'>{select}</p>
                    <div id='activeeffect'>
                        <img onClick={()=>
                            {
                                let index=findprop(select)
                                let name
                                index==properties.length-1?name=properties[0]:name=properties[index+1]
                                setselect(name)
                            }} src={Rightarrow}/>
                    </div>
                </div>
                
                <Swiper 
                
                modules={[Pagination, Navigation, Autoplay]}
                className="myswiper3"
                direction='horizontal'
                pagination= {{
                    el: '.swiper-custom-pagination',
                  }}
                loop="true"
                onReachEnd={()=>{
                    let index=findprop(select)
                    index==properties.length-1?setselect(properties[0]):setselect(properties[index+1])
                }}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}>
                    {
                        sliderdata?.map((e,i)=>
                        {
                            return(
                                <SwiperSlide className='swiper-slide' key={i}>
                                    <div className='relative w-full h-[400px]'>
                                        <img onClick={()=>setzoomimage(true)} src={e[0]} className="object-contain w-full"/>
                                    </div>
                                    <div className='flex justify-end mr-[2px]'>
                                        <div id='activeeffect' className="absolute top-[84%] flex gap-[10px] items-center px-[9px] py-[15px] bg-black/[.56] backdrop-opacity-10" onClick={()=>
                                            {
                                                handleclick()
                                                
                                            }}>
                                                <p className="text-[15px] text-white font-[500] leading-[30px]">View All</p>
                                                <div>
                                                    <img className='w-full' src={expicon}/>
                                                </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
                <div className="swiper-custom-pagination"/>
            </div>
            
            <div  style={{display:zoomimage?"block":"none"}} className='after' >
                    <div className='w-full h-full flex flex-col items-center justify-center'>
                        <div id='activeeffect' onClick={restorezoomdefault} className='w-full h-full py-[13px]'>
                            <img src={Back}/>
                        </div>
                        <div className='flex justify-center items-start w-[100%] lg:gap-[20px]'>
                        
                            <div className='w-[100%]'>
                                <Swiper 
                                modules={[Pagination, Navigation, Autoplay]}
                                direction='horizontal'
                                navigation={{
                                    prevEl: navigationPrevRef.current,
                                    nextEl: navigationNextRef.current,
                                  }}
                                onBeforeInit={(swiper) => {
                                    swiper.params.navigation.prevEl = navigationPrevRef.current;
                                    swiper.params.navigation.nextEl = navigationNextRef.current;
                               }}
                                loop="true"
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                }}>
                                    {
                                        modaldata?.map((e,i)=>
                                        {
                                            return(
                                                <SwiperSlide className={`relative`} key={i}>
                                                    <div className='h-[500px]'>
                                                        <img className='w-full h-full object-cover' src={e}/>
                                                    </div>
                                                    
                                                </SwiperSlide>
                                            )
                                        })
                                    }
                                    <div className='w-full absolute top-[50%] z-10 flex justify-between'>
                                        <div id='activeeffect' className='' ref={navigationPrevRef}><img src={Left}/></div>
                                        <div id='activeeffect' className='' ref={navigationNextRef}><img src={Right}/></div>
                                    </div>
                                </Swiper>
                                {/* <div className="swiper-custom-navigation">
                                    <div className="custom-prev-icon"></div>
                                    <div className="custom-next-icon"></div>
                                </div> */}
                            </div>
                            {/* <div className='sm:w-[10%] lg:w-[5%]'>
                                <AiOutlineClose className='' size="25px" color='black' style={{cursor:"pointer"}} onClick={()=>{
                                    setzoomimage(false)
                                    // swiper.autoplay.start()
                                } }/>
                            </div> */}
                        </div>
                        <div onClick={restorezoomdefault} className='w-full h-full'></div>
                    </div>
                </div>


                <div  style={{display:zoomimagelarge?"flex":"none"}} className='flex after' >
                    <div onClick={restorezoomdefault} className='w-[10%] h-[80%]'></div>
                    <div className='w-[80%] m-auto h-full flex flex-col items-center justify-center'>
                        <div id='activeeffect' onClick={restorezoomdefault} className='w-full h-[10%] py-[13px]'>
                            <img src={Back}/>
                        </div>
                        <div className='overflow-scroll w-full h-full grid grid-cols-2 gap-[10px]'>

                                {
                                    modaldata?.map((e,i)=>
                                    {
                                        return(
                                            <div className=''>
                                                    <img className='w-full h-full object-cover' src={e}/>
                                            </div>
                                        )
                                    })
                                }
                        </div>
                        <div onClick={restorezoomdefault} className='w-full h-[10%]'></div>
                    </div>
                    <div onClick={restorezoomdefault} className='w-[10%] h-[80%]'></div>
                </div>
            {/* <div className='sm:flex mt-[0px] justify-around items-center lg:hidden'>
                <img src={images['Arrow left.png']} onClick={()=>
                {
                    let index=findprop(select)
                    let name
                    index==0?name=properties[properties.length-1]:name=properties[index-1]
                    setselect(name)
                }}/>
                <img src={images['Arrow right.png']} onClick={()=>
                {
                    let index=findprop(select)
                    let name
                    index==properties.length-1?name=properties[0]:name=properties[index+1]
                    setselect(name)
                }}/>
            </div> */}
            
        </div>
  );
};

export default SwiperCompcopy;